import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';


import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
           style={{ overflowX: 'auto',whiteSpace:'nowrap' }}

            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    onClick={() => props.onHistorial(row)}
                                />
                            </Tooltip>

                 
                        </div>
                    )
                },
                {
                    title: 'Fecha Comprobante',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Nro Comprobante',
                    dataIndex: 'serieDocumentoComprobante',
                    key: 'serieDocumentoComprobante',
                    sorter: true
                },
    
                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'nombreTipoComprobante',
                    key: 'nombreTipoComprobante',
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencimiento',
                    key: 'fechaVencimiento',
                    sorter: true
                },
                {
                    title: 'Dias Vencidos',
                    dataIndex: 'diasVencido',
                    key: 'diasVencido',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                if (value < 0) {
                                    return <Tag color={"red"}>{Math.abs(value)}</Tag>;

                                } else {
                                    if (row.idCuentasEstado == 2) {
                                        return <Tag color={value > 0 || value == 0? 'brown' : 'green'}>{value > 0 ? 0 : value}</Tag>;

                                    } else {

                                        //return <Tag color={"green"}>{value}</Tag>;
                                        return <Tag color={value == 0 ? 'brown' : 'green'}>{value == 0 ? 0 : value}</Tag>;

                                    }

                                }
                            })()}

                        </div>)
                    }
                },

                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Proveedor',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    sorter: true
                },
                {
                    title: 'Cuota',
                    dataIndex: 'cuota',
                    key: 'cuota',
                    sorter: true
                },
                {
                    title: 'Moneda Original',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },

        /*         {
                    title: 'Total',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'totalSoles',
                            key: 'totalSoles',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'totalDolares',
                            key: 'totalDolares',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        }
                    ]
                }, */

                {
                    title: 'Total',
                    dataIndex: 'totalSoles',
                    key: 'totalSoles',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    ) 
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },

                {
                    title: 'Pagado',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'canceladoSoles',
                            key: 'canceladoSoles',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'canceladoDolares',
                            key: 'canceladoDolares',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        }
                    ]
                },
                {
                    title: 'Saldo a Pagar',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            className: 'parent-group parent-group-2',
                            dataIndex: 'saldoSoles',
                            key: 'saldoSoles',
                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        },
                        {
                            title: 'Dólares',
                            className: 'parent-group parent-group-2',

                            dataIndex: 'saldoDolares',
                            key: 'saldoDolares',
                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        }
                    ]
                },
    
        
                {
                    title: 'Estado',
                    dataIndex: 'idCuentasEstado',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value,row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 2: //registado
                                        return <Tag color={"red"}>{row.nombreCuentasEstado}</Tag>;
                                    case 1://ANULADA
                                        return <Tag color={"green"}>{row.nombreCuentasEstado}</Tag>;
                                    case 3://APERTURADA
                                        return <Tag color={"blue"}>{row.nombreCuentasEstado}</Tag>;
                                    case 4://CERRADO
                                        return <Tag color={"orange"}>{row.nombreCuentasEstado}</Tag>;
                                    default:
                                        return <Tag color={"green"}>{row.nombreCuentasEstado}</Tag>;
                                }
                            })()}

                        </div>)
                    }
                }
            ]}
        />
    );
}